import Vue from 'vue'
import Vuex from 'vuex'
import cpAuth from './modules/cpAuth.store'
import cpOrder from './modules/cpOrder.store'
import cpReorder from './modules/cpReorder.store'
import loader from './modules/loader.store'
import progress from './modules/progress.store'
import cart from './modules/cart.store'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: false, // process.env.NODE_ENV !== 'production',
  modules: {
    cpAuth,
    cpOrder,
    cpReorder,
    loader,
    progress,
    cart
  }
})
